import { View } from 'react-native';
import styled from 'styled-components/native';

export const PeriodSelectionButtonWrapper = styled(View)`
    position: relative;
`;
